import React from 'react';
import { useTranslation } from 'react-i18next';
import NotificationDropdown from './NotificationDropdown';
import ThemeToggle from './ThemeToggle';
import LanguageToggle from './LanguageToggle';

const AdminTopBar = ({
  title,
  onMenuClick,
  showMenuButton = true,
  isNotificationOpen = false,
  onNotificationToggle,
  notificationUnreadCount = 0,
  leftExtra = null,
  actions = null,
  beforeNotifications = null,
}) => {
  const { t } = useTranslation('nav');
  const { t: tNotifications } = useTranslation('notifications');
  const { t: tCommon } = useTranslation('common');
  const resolvedTitle = title || t('adminDashboardTitle');

  return (
    <header className="h-16 flex items-center justify-between border-b border-border px-4 lg:px-8 bg-surface/95 backdrop-blur z-40 shrink-0 sticky top-0 gap-3 overflow-visible shadow-sm dark:shadow-[0_1px_0_0_rgba(255,255,255,0.04)]">
      <div className="flex items-center gap-3 min-w-0 flex-1 overflow-visible">
        {showMenuButton && (
          <button 
            className="md:hidden text-text-secondary hover:text-primary transition-colors shrink-0"
            onClick={onMenuClick}
            aria-label={tCommon('toggleMenu')}
          >
            <span className="material-symbols-outlined">menu</span>
          </button>
        )}
        <h2 className="text-primary text-lg font-bold tracking-tight shrink-0">{resolvedTitle}</h2>
        {leftExtra}
      </div>
      <div className="flex items-center gap-3 shrink-0">
        {actions}
        <div className="flex items-center gap-3 sm:gap-4">
          <LanguageToggle />
          <ThemeToggle />
          {beforeNotifications}
          {onNotificationToggle ? (
            <button
              onClick={onNotificationToggle}
              className={`relative text-text-secondary hover:text-primary transition-colors p-1 rounded-md ${isNotificationOpen ? 'bg-slate-100 dark:bg-slate-700/50 text-primary' : ''}`}
              aria-label={tNotifications('ariaLabel')}
            >
              <span className="material-symbols-outlined">notifications</span>
              {notificationUnreadCount > 0 && (
                <span className="absolute -top-0.5 -right-0.5 bg-red-500 text-white text-xs font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
                  {notificationUnreadCount > 9 ? tNotifications('unreadBadgeMax') : notificationUnreadCount}
                </span>
              )}
            </button>
          ) : (
            <NotificationDropdown />
          )}
        </div>
      </div>
    </header>
  );
};

export default AdminTopBar;
